import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, isRef as _isRef, Suspense as _Suspense, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/ecosafety_mc_logo_2017.png'


const _hoisted_1 = { class: "layout-content" }
const _hoisted_2 = { class: "ecos-footer" }
const _hoisted_3 = { class: "ecos-footer__container" }
const _hoisted_4 = { class: "ecos-footer__col ecos-footer__brand" }
const _hoisted_5 = { class: "ecos-footer__copy" }
const _hoisted_6 = { class: "ecos-footer__col" }
const _hoisted_7 = { class: "gu-confirm-icon" }
const _hoisted_8 = { class: "gu-confirm-fields" }
const _hoisted_9 = { class: "gu-confirm-actions" }

import {
  watchEffect,
  computed,
  reactive,
  ref,
  watch,
} from 'vue';
import ModalContainer from '~components/modals/ModalContainer.vue';
import { useSocket } from '@/utils/socket';
import { useRoute } from 'vue-router';
import { useMainStore } from '@/store';
import { useAuthStore } from '@/store/auth/authModule';
import {
  storeToRefs,
  getActivePinia,
  Pinia,
  Store,
} from 'pinia';
import AppLoader from '~components/AppLoader.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
// import AuthLayout from '@/layouts/AuthLayout.vue';
import { height, tabsHeaderHeight } from './constants';

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const $ResetPinia = (): void => {
  const pinia = getActivePinia() as ExtendedPinia;

  if (!pinia) {
    throw new Error('There is no stores');
  }

  pinia._s.forEach((store) => {
    store.$reset();
  });
};

const authStore = useAuthStore();

const isLoading = ref(false);

const { isAuth, needChange } = storeToRefs(authStore);

const authInProcess = ref(false);
const isPwd = ref(true);
const isPwdRepeat = ref(true);
const data = reactive({
  newPpassword: '',
  newPpasswordRepeat: '',
});

const {
  modal,
  maximized,
  reportMode,
} = storeToRefs(useMainStore());

const { emit, on, connected } = useSocket();

// onMounted(() => {
//   const offRefresh = on('refresh', (data) => {
//     console.log('Получено обновление:', data);
//     // обнови состояние, store, dispatch event и т.д.
// });

// onUnmounted(() => {
//   offRefresh();
// });
// onBeforeMount(async () => {
//   isLoading.value = true;
//   isLoading.value = false;
// });

const closeModal = () => {
  useMainStore().closeModal();
};

watch(
  () => authStore.processing,
  () => {
    isLoading.value = authStore.processing;
  },
);

const tryChangePass = async () => {
  if (data.newPpassword === data.newPpasswordRepeat) {
    let hash = '';
    if (authStore.hash) {
      hash = authStore.hash;
    }
    const result = await authStore.changePassword(data.newPpassword, hash);
    if (result) {
      needChange.value = false;
      authStore.hash = '';
      authStore.autenticate();
      useMainStore().showMessage(authStore.user.err_text);
    }
  } else {
    useMainStore().showMessage('Пароли не совпадают');
  }
};

const logout = () => {
  $ResetPinia();
  useAuthStore().logout();
};

const gradientClass = computed(() => {
  console.log('route.name', route.name);
  switch (route.name) {
    case undefined:
      return 'bg-login-layout';
    case 'Login':
      return 'bg-login-layout';
    default:
      return 'bg-main-layout';
  }
});

watchEffect(() => {
  document.body.className = gradientClass.value;
});

const wrapperStyleHeight = `calc(100vh - ${height}px)`;
const tabsWrapperStyleHeight = `calc(100vh - ${height + tabsHeaderHeight}px)`;

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hHh lpR lFf",
    class: "layout"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isAuth) && !authInProcess.value)
          ? (_openBlock(), _createBlock(BaseLayout, {
              key: 0,
              isLoading: isLoading.value
            }, null, 8, ["isLoading"]))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ]),
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_q_inner_loading, {
            key: 0,
            showing: isLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(AppLoader)
            ]),
            _: 1
          }, 8, ["showing"]))
        : _createCommentVNode("", true),
      _createElementVNode("footer", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "ecos-footer__logo-plate" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Эко-безопасность",
                class: "ecos-footer__logo"
              })
            ], -1)),
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "ecos-footer__title" }, " Группа компаний Эко-безопасность ", -1)),
              _createElementVNode("div", _hoisted_5, " © 2011–" + _toDisplayString(new Date().getFullYear()), 1)
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ecos-footer__divider" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ecos-footer__label" }, "Контакты", -1)),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              flat: "",
              dense: "",
              class: "ecos-footer__link",
              icon: "call",
              label: "+7 (812) 325-03-05",
              href: "tel:+78123250305"
            }),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              flat: "",
              dense: "",
              class: "ecos-footer__link",
              icon: "email",
              label: "info@ecosafety.ru",
              href: "mailto:info@ecosafety.ru"
            })
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "ecos-footer__divider" }, null, -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "ecos-footer__col ecos-footer__col--address" }, [
            _createElementVNode("div", { class: "ecos-footer__label" }, "Адрес"),
            _createElementVNode("div", { class: "ecos-footer__address" }, [
              _createTextVNode(" 191119, Санкт-Петербург,"),
              _createElementVNode("br"),
              _createTextVNode(" ул. Достоевского, 40-44 ")
            ])
          ], -1))
        ])
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: _unref(needChange),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(needChange) ? (needChange).value = $event : null)),
        persistent: "",
        "transition-show": "scale",
        "transition-hide": "scale",
        class: "first-acquaintance"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "gu-confirm-card" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_q_icon, {
                  name: "lock",
                  size: "26px"
                })
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "gu-confirm-title" }, "Измените пароль", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "gu-confirm-text" }, " Это ваш первый вход в личный кабинет. Задайте новый пароль, чтобы продолжить. ", -1)),
              _createVNode(_component_q_form, {
                onSubmit: _withModifiers(tryChangePass, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_q_input, {
                      dense: "",
                      outlined: "",
                      type: isPwd.value ? 'password' : 'text',
                      modelValue: data.newPpassword,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.newPpassword) = $event)),
                      label: "Новый пароль",
                      "lazy-rules": "",
                      "bg-color": "white",
                      rules: [
                val => val !== null && val !== '' || 'Обязательное поле',
              ]
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: isPwd.value ? 'visibility_off' : 'visibility',
                          class: "cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (isPwd.value = !isPwd.value))
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["type", "modelValue", "rules"]),
                    _createVNode(_component_q_input, {
                      dense: "",
                      outlined: "",
                      type: isPwdRepeat.value ? 'password' : 'text',
                      modelValue: data.newPpasswordRepeat,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.newPpasswordRepeat) = $event)),
                      label: "Еще раз",
                      "lazy-rules": "",
                      "bg-color": "white",
                      rules: [
                val => val !== null && val !== '' || 'Обязательное поле',
              ]
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: isPwdRepeat.value ? 'visibility_off' : 'visibility',
                          class: "cursor-pointer",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (isPwdRepeat.value = !isPwdRepeat.value))
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["type", "modelValue", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_q_btn, {
                      unelevated: "",
                      "no-caps": "",
                      ripple: false,
                      icon: "logout",
                      class: "gu-btn gu-btn-secondary",
                      label: "Выйти",
                      onClick: _withModifiers(logout, ["prevent"])
                    }),
                    _createVNode(_component_q_btn, {
                      unelevated: "",
                      "no-caps": "",
                      ripple: false,
                      icon: "save",
                      class: "gu-btn gu-btn-primary",
                      label: "Сохранить",
                      type: "submit"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_dialog, {
        modelValue: _unref(modal),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(modal) ? (modal).value = $event : null)),
        maximized: _unref(maximized),
        "full-height": _unref(maximized),
        "full-width": _unref(maximized),
        class: _normalizeClass({
        'prepare-report': _unref(reportMode),
      })
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(ModalContainer, { onClose: closeModal })
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["modelValue", "maximized", "full-height", "full-width", "class"])
    ]),
    _: 1
  }))
}
}

})